<script setup lang="ts">
import type { Image } from '@sanity/types';
import BaseImage from '@pkg/ui/components/base/BaseImage.vue';
import VideoComponent from '@pkg/ui/components/base/Video.vue';
import VideoBackground from '@pkg/ui/components/base/VideoBackground.vue';
import { VideoType } from '@pkg/sanity-utils/constants/video';
import ImageComponent from './ImageVideoImage.vue';

const props = defineProps<{
  mediaType: 'image' | 'video';
  video?: {
    url?: string;
    webm?: string;
    ogg?: string;
    fallbackImage?: Image;
    controls?: boolean;
    autoplay?: boolean;
    videoType?: VideoType;
  }
  image?: Image;
  parallax?: boolean;
}>();

</script>

<template>
  <section>
    <VideoBackground v-if="props.video?.url && props.video.videoType !== VideoType.HOSTED" :url="props.video.url" :fallback-image="props.video.fallbackImage" :controls="props.video.controls ?? true" :autoplay="props.video.autoplay ?? false" />
    <div v-if="props.mediaType === 'image' && props.image">
      <ImageComponent v-if="props.image" :image="props.image" :parallax="props.parallax" />
    </div>
    <div v-if="props.mediaType === 'video' && props.video?.url">
      <VideoComponent
        :url="props.video.url"
        class="c-video"
        :webm="props.video.webm"
        :ogg="props.video.ogg"
        :video-type="props.video.videoType"
        :controls="props.video.controls"
        :autoplay="props.video.autoplay"
      >
        <template v-if="props.video.fallbackImage" #cover>
          <BaseImage :image="props.video.fallbackImage" />
        </template>
      </VideoComponent>
    </div>
  </section>
</template>

<style scoped>
.c-video {
  width: 100%;
}
</style>
